import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import ScanRunStateBadge from "shared/Scan/StateBadge";

import { ScansListItem } from "../../../types";

const ScansTableStatusCell = ({
  item: scan,
  ...cellProps
}: TableSimpleCellProps<ScansListItem>) => (
  <TableSimpleCell {...cellProps}>
    {scan.latestRun ? <ScanRunStateBadge state={scan.latestRun.state} /> : <TableCellEmpty />}
  </TableSimpleCell>
);

export default ScansTableStatusCell;
